export function IconNotificationStatus({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.0167 2.42505C7.25837 2.42505 5.01671 4.66672 5.01671 7.42505V9.83339C5.01671 10.3417 4.80004 11.1167 4.54171 11.55L3.58337 13.1417C2.99171 14.125 3.40004 15.2167 4.48337 15.5834C8.07504 16.7834 11.95 16.7834 15.5417 15.5834C16.55 15.25 16.9917 14.0584 16.4417 13.1417L15.4834 11.55C15.2334 11.1167 15.0167 10.3417 15.0167 9.83339V7.42505C15.0167 4.67505 12.7667 2.42505 10.0167 2.42505Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5584 2.66672C11.3001 2.59172 11.0334 2.53339 10.7584 2.50005C9.95841 2.40005 9.19175 2.45839 8.47508 2.66672C8.71675 2.05005 9.31675 1.61672 10.0167 1.61672C10.7167 1.61672 11.3167 2.05005 11.5584 2.66672Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5166 15.8834C12.5166 17.2584 11.3916 18.3834 10.0166 18.3834C9.33327 18.3834 8.69994 18.1 8.24994 17.65C7.79994 17.2 7.51660 16.5667 7.51660 15.8834"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.8334 6.66672C17.2141 6.66672 18.3334 5.5474 18.3334 4.16672C18.3334 2.78601 17.2141 1.66672 15.8334 1.66672C14.4527 1.66672 13.3334 2.78601 13.3334 4.16672C13.3334 5.5474 14.4527 6.66672 15.8334 6.66672Z"
        fill="currentColor"
      />
    </svg>
  );
}
